import { createFileRoute } from "@tanstack/react-router"

import { ReminderActionCard } from "@/components/guild-war/reminder-action-card"

export const Route = createFileRoute("/_authed/_admin/guild-war/actions")({
  component: CommandCenterPage,
})

function CommandCenterPage() {
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <ReminderActionCard />
    </div>
  )
}
